import React from 'react';
import './ExpandButton.css';

function ExpandButton({ hasSubtasks, isExpanded, onToggleExpand }) {
  if (!hasSubtasks) {
    return <span className="expand-spacer"></span>;
  }

  return (
    <button
      className="expand-button text-non-selectable"
      onClick={onToggleExpand}
      aria-label={isExpanded ? 'Collapse' : 'Expand'}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        className={`expand-icon ${isExpanded ? 'expanded' : ''}`}
      >
        <path
          d="M4 2 L8 6 L4 10"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default ExpandButton;


